import InvoiceModel from 'src/models/InvoiceModel';
import environmentStore from 'src/stores/EnvironmentStore';

export function getPdfURL(invoice: InvoiceModel): string | undefined {
  if (!invoice.isIdValid) {
    return undefined;
  }
  return `https://${environmentStore.pdfHost}/${invoice.id}.pdf`;
}
